import { z } from "zod";
export interface AudioShakeAsset {
  name: string;
  id: string;
  fileType: string;
  format: string;
  link: string;
}

export const AudioShakeAssetSchema = z.object({
  name: z.string(),
  id: z.string(),
  fileType: z.string(),
  format: z.string(),
  link: z.string(),
});

export const AudioShakeJobStatusSchema = z.enum([
  "created",
  "processing",
  "completed",
  "error",
]);

export const AudioShakeJobSchema = z.object({
  id: z.string(),
  clientId: z.string(),
  createdAt: z.string(),
  startedAt: z.string(),
  updatedAt: z.string(),
  requestId: z.string(),
  licenseId: z.string(),
  metadata: z.object({
    format: z.string(),
    name: z.string(),
  }),
  callbackUrl: z.string(),
  status: AudioShakeJobStatusSchema,
  statusInfo: z
    .object({
      code: z.number().optional(),
      message: z.string().optional(),
    })
    .optional(),
  sourceAsset: AudioShakeAssetSchema,
  outputAssets: z.array(AudioShakeAssetSchema),
});

export const AudioShakeAlignmentWordSchema = z.object({
  start: z.number(),
  end: z.number(),
  text: z.string(),
});

export const AudioShakeAlignmentLineSchema = z.object({
  start: z.number(),
  end: z.number(),
  text: z.string(),
  words: z.array(AudioShakeAlignmentWordSchema),
});

export const AudioShakeAlignmentOutputSchema = z.object({
  text: z.string(),
  lines: z.array(AudioShakeAlignmentLineSchema),
});

export type AudioShakeJob = z.infer<typeof AudioShakeJobSchema>;

export interface AudioShakeTransciptionOutput {
  text: string;
}

export type AudioShakeAlignmentOutput = z.infer<
  typeof AudioShakeAlignmentOutputSchema
>;

export type AudioShakeAlignmentLine = z.infer<
  typeof AudioShakeAlignmentLineSchema
>;

export type AudioShakeAlignmentWord = z.infer<
  typeof AudioShakeAlignmentWordSchema
>;

export type AudioShakeJobStatus = z.infer<typeof AudioShakeJobStatusSchema>;

export interface AudioShakeJobResponse {
  job: AudioShakeJob;
}

export interface AudioShakeOptions {
  accessToken: string;
  prefixUrl?: string;
}

export const AudioShakeJobTypeSchema = z.enum(["transcription", "alignment"]);
export type AudioShakeJobType = z.infer<typeof AudioShakeJobTypeSchema>;
